import axios from 'axios';

const cleanAxiosInstance = axios.create();

const uploadFile = async (file: File, presignedUrl: string) => {
  const headers: Record<string, string> = {
    'Content-Type': file.type
  };

  try {
    const response = await cleanAxiosInstance.put(presignedUrl, file, { headers });

    if (response.status >= 400 && response.status < 600) {
      console.error(`File upload failed with status: ${response.status}`);
      return { success: false, status: response.status };
    }

    return { success: true, status: response.status };
  } catch (error) {
    console.error('Error uploading file:', error);
    throw error;
  }
};

export const uploadFiles = async (
  filesToUpload: { file: File; presignedUrl: string }[]
): Promise<{
  successfulUploads: Array<{ file: File; status: number }>;
  failedUploads: Array<{ file: File; error: any }>;
}> => {
  try {
    const uploadPromises = filesToUpload.map(async (fileToUpload) => {
      try {
        const result = await uploadFile(fileToUpload.file, fileToUpload.presignedUrl);
        return { file: fileToUpload.file, success: true, status: result.status };
      } catch (error) {
        return { file: fileToUpload.file, success: false, error };
      }
    });

    const results = await Promise.all(uploadPromises);

    const successfulUploads = results.filter((result) => result.success).map((result) => ({ file: result.file, status: result.status! }));

    const failedUploads = results.filter((result) => !result.success).map((result) => ({ file: result.file, error: result.error }));

    return {
      successfulUploads,
      failedUploads
    };
  } catch (error) {
    console.error('Unexpected error while uploading files', error);
    // Return an empty result structure in case of unexpected errors
    return {
      successfulUploads: [],
      failedUploads: filesToUpload.map((fileToUpload) => ({
        file: fileToUpload.file,
        error: error || 'Unknown error'
      }))
    };
  }
};
